import { render, staticRenderFns } from "./template-edit-option.vue?vue&type=template&id=6324857a&scoped=true&"
import script from "./template-edit-option.vue?vue&type=script&lang=ts&"
export * from "./template-edit-option.vue?vue&type=script&lang=ts&"
import style0 from "./template-edit-option.vue?vue&type=style&index=0&id=6324857a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324857a",
  null
  
)

export default component.exports